import Kasauli from "../images/Kasauli.jpg";
import Jabalpur from "../images/JabalpurFalls.jpg";
import Jaipur from "../images/Jaipur.jpg";
import Manali from "../images/Manali.jpg";
import Rishikesh from "../images/RishiKesh.jpg";
import Sunset from "../images/Sunset.jpg";

const imagesList = [
    {
        key: 0,
        title: "Kasauli, Himachal Pradesh, India",
        url: Kasauli,
        alt: "View of hills in Kasauli region of India.",
        description: "Photo clicked on Oneplus 8 pro in November 2021"
    },
    {
        key: 1,
        title: "Dhuandhar Falls (Jabalpur, Madhya Pradesh, India)",
        url: Jabalpur,
        alt: "View of a waterfall in Jabalpur region of India.",
        description:  "Photo clicked on Oneplus 8 pro in January 2022"
    },
    {
        key: 2,
        title: "Amber Fort (Jaipur, Rajasthan, India)",
        url: Jaipur,
        alt: "View of Amber Fort in Jaipur region of India.",
        description: "Photo clicked on Oneplus 6T in April 2019"
    },
    {
        key: 3,
        title: "Manali, Himachal Pradesh, India",
        url: Manali,
        alt: "View of snowy mountains in Manali region of India.",
        description: "Photo clicked on Sony Xperia M in June 2014"
    },
    {
        key: 4,
        title: "Rishikesh, Uttrakhand, India",
        url: Rishikesh,
        alt: "View of hills and river in Rishikesh region of India.",
        description: "Photo clicked on Oneplus 6T in October 2019"
    },
    {
        key: 5,
        title: "Sunset, Gilbert Trail (Kasauli, Himachal Pradesh, India)",
        url: Sunset,
        alt: "View of sunset taken in Kasauli region of India.",
        description: "Photo clicked on Oneplus 8 pro in November 2021"
    }
];

export default imagesList;